export enum NeedToControlled {
    HYGIENE = 'hygiene',
    CHANGE_CLOTHES = 'change-clothes',
    DRYING_CLOTHES = 'drying-clothes',
    OTHER = 'other',
}

export const needToControlledTranslates = {
    [NeedToControlled.HYGIENE]: 'students:form.labels.hygiene',
    [NeedToControlled.CHANGE_CLOTHES]: 'students:form.labels.change_clothes',
    [NeedToControlled.DRYING_CLOTHES]: 'students:form.labels.drying_clothes',
    [NeedToControlled.OTHER]: 'students:form.labels.other',
};
